export default [
  {
    type: 'input',
    placeholder: '昵称',
    filed: 'nickName',
    default: ''
  },
  {
    type: 'input',
    placeholder: '手机号',
    filed: 'phone',
    default: ''
  },
  {
    type: 'datepicker',
    filed: 'daterange',
    params: {
      start: 'startTime',
      end: 'endTime'
    },
    default: '',
    startplh: '注册开始时间',
    endplh: '注册结束时间'
  },
  {
    type: 'select',
    placeholder: '手机系统',
    filed: 'mobileType',
    default: '',
    options: [
      {
        code: 'android',
        name: 'Android'
      },
      {
        code: 'ios',
        name: 'iOS'
      }
    ]
  }
]
